import { useTranslation } from "react-i18next";
import { Page } from "../../../../components/Page";
import { WithAuthorization } from "../../../../context";
import { useState } from "react";
import { Center, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { Card } from "../../../../components/Card";
import ExposureToLitigationDescription from "./components/ExposureToLitigationDescription";
import SuitsAgainstCorporations from "./components/SuitsAgainstCorporations";
import SuitsAgainstGovernments from "./components/SuitsAgainstGovernments";

function ExposureToLitigation() {
  const { t } = useTranslation("translation", {
    keyPrefix: "exposureToLitigation"
  });
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>

      <Center>
        <Heading size="sm" marginBlockStart={5} padding={2}
                 width={200} borderRadius={5}
                 backgroundColor="white" textAlign="center">Global, excl. USA</Heading>
      </Center>

      <Card marginBlockStart={5}>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} overflow="auto">
          <Center>
            <TabList borderBottom="none" overflow="auto">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.description")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.suitsAgainstCorporations")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.suitsAgainstGovernments")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <ExposureToLitigationDescription />
            </TabPanel>
            <TabPanel padding="0">
              <SuitsAgainstCorporations />
            </TabPanel>
            <TabPanel padding="0">
              <SuitsAgainstGovernments />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(ExposureToLitigation);